import React from "react";

import { View } from "@/styles/reactnative";
import AuthButtonLists from "../AuthButtonLists";

const AssetsFooter = () => {
  return (
    <View
      style={{
        alignItems: "flex-start",
        justifyContent: "flex-start",
        marginTop: 20,
      }}
    >
      <AuthButtonLists title={"overview"} go={"/asset?tab=1"} />
      <AuthButtonLists title={"spot"} go={"/asset?tab=2"} />
      <AuthButtonLists title={"derivatives"} go={"/asset?tab=3"} />
      {/* <AuthButtonLists title={'earn'} go={'@/assets'} /> */}
    </View>
  );
};

export default AssetsFooter;
